import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Se un link di autenticazione (es. recovery) atterra con access_token/code
 * sia in hash (#...) che in query (?...) portiamo l'utente su "/auth"
 * mantenendo i parametri per completare correttamente il flusso.
 */
const AuthHashRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const hash = location.hash ?? "";
    const search = location.search ?? "";

    const hashParams = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const searchParams = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);

    const type = searchParams.get("type") ?? hashParams.get("type");

    const hasAuthPayload = Boolean(
      // payload classico (token o code)
      searchParams.get("access_token") ||
        searchParams.get("code") ||
        hashParams.get("access_token") ||
        hashParams.get("code") ||
        // alcuni redirect mantengono solo type=recovery (sessione già creata)
        type === "recovery"
    );

    const hasAuthError = Boolean(
      searchParams.get("error") ||
        searchParams.get("error_code") ||
        hashParams.get("error") ||
        hashParams.get("error_code")
    );

    if (!hasAuthPayload && !hasAuthError) return;

    // Qualsiasi callback auth (successo o errore) deve atterrare su /auth (poi la pagina decide cosa mostrare).
    if (location.pathname !== "/auth") {
      navigate({ pathname: "/auth", search, hash }, { replace: true });
    }
  }, [location.hash, location.search, location.pathname, navigate]);

  return null;
};

export default AuthHashRedirect;
